<template>
  <div :class="['flex flex-col', itemsClass]">
    <h4 :class="[sizeClass, 'font-semibold tracking-tight font-inter', textColorClass, alignClass]">
      <slot />
    </h4>
    <div v-if="underline" :class="['mt-1 rounded-full', underlineHeightClass, underlineWidthClass, underlineBgClass]"></div>
  </div>
</template>

<script>
export default {
  name: 'Subheader',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    variant: {
      type: String,
      default: 'slate' // slate, indigo, blue, green, orange, rose
    },
    size: {
      type: String,
      default: 'sm' // sm, md, lg
    },
    underline: {
      type: Boolean,
      default: false
    },
    underlineWidth: {
      type: String,
      default: 'sm' // sm, md, lg
    }
  },
  computed: {
    alignClass() {
      if (this.align === 'left') return 'text-left'
      if (this.align === 'right') return 'text-right'
      return 'text-center'
    },
    itemsClass() {
      if (this.align === 'left') return 'items-start'
      if (this.align === 'right') return 'items-end'
      return 'items-center'
    },
    textColorClass() {
      const map = {
        slate: 'text-gray-600',
        indigo: 'text-indigo-600',
        blue: 'text-blue-600',
        green: 'text-green-600',
        orange: 'text-orange-600',
        rose: 'text-rose-600'
      }
      return map[this.variant] || 'text-gray-600'
    },
    sizeClass() {
      if (this.size === 'lg') return 'text-lg md:text-xl'
      if (this.size === 'md') return 'text-base'
      return 'text-sm'
    },
    underlineBgClass() {
      const map = {
        slate: 'bg-slate-300',
        indigo: 'bg-indigo-400',
        blue: 'bg-blue-400',
        green: 'bg-green-400',
        orange: 'bg-orange-400',
        rose: 'bg-rose-400'
      }
      return map[this.variant] || 'bg-slate-300'
    },
    underlineWidthClass() {
      if (this.underlineWidth === 'lg') return 'w-24'
      if (this.underlineWidth === 'sm') return 'w-12'
      return 'w-16'
    },
    underlineHeightClass() {
      if (this.underlineWidth === 'lg') return 'h-1.5'
      if (this.underlineWidth === 'sm') return 'h-1'
      return 'h-1'
    }
  }
}
</script>

<style scoped>
.font-inter {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}
</style>


